import React, { useRef } from 'react';
import { X } from 'lucide-react';
import toast from 'react-hot-toast';

interface AudioUploadSlotProps {
    label: string;
    file: File | null;
    setFile: (file: File | null) => void;
    disabled?: boolean;
    onDelete?: () => void;
}

export const AudioUploadSlot: React.FC<AudioUploadSlotProps> = ({
    label,
    file,
    setFile,
    disabled = false,
    onDelete
}) => {
    const inputRef = useRef<HTMLInputElement>(null);

    const handleFileChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const uploadedFile = e.target.files?.[0];
        if (uploadedFile && uploadedFile.type.startsWith("audio/")) {
            setFile(uploadedFile);
        } else {
            toast.error("Please upload a valid audio file.");
        }
    };

    const handleBrowseClick = () => {
        if (!disabled) inputRef.current?.click();
    };

    return (
        <div className="flex items-center gap-2">
            { file ? (
                <div className="flex items-center bg-muted rounded px-3 py-2 max-w-[220px]">
                    <span className="text-sm truncate max-w-[160px] text-card-foreground">{ file.name }</span>
                    <button
                        onClick={ onDelete ? onDelete : () => setFile(null) }
                        className="ml-2 text-muted-foreground hover:text-destructive cursor-pointer"
                    >
                        <X size={ 14 } />
                    </button>
                </div>
            ) : (
                <button
                    onClick={ handleBrowseClick }
                    disabled={ disabled }
                    className={ `px-4 py-2 rounded text-sm ${disabled
                        ? 'bg-muted text-muted-foreground cursor-not-allowed'
                        : 'btn-primary cursor-pointer'
                        }` }
                >
                    Upload { label }
                </button>
            ) }
            <input
                ref={ inputRef }
                type="file"
                accept="audio/*"
                className="hidden"
                onChange={ handleFileChange }
            />
        </div>
    );
}; 